module.exports = __webpack_public_path__ + "assets/img/advantage3.14005ff1.png";